module.exports = __webpack_public_path__ + "static/cellcategorias-570805a5a3e8e4366a27148face792a1.png";